// eslint-disable-next-line import/prefer-default-export
export const availableRegions = ['FR', 'US', 'GB'] as const;

export type AvailableRegion = (typeof availableRegions)[number];
